import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';

import { Respuesta } from '../_models/shared/_index';
import { VersionPorcentaje, Mix } from '../_models/asignacion-mix/index';
import { Router } from '@angular/router';
import { ConfiguracionArbolLazy } from '../_models/arbol-lazy/configuracion-arbol-lazy';
import { ErrorService } from './error.service';

@Injectable()
export class TmmvService {
	constructor(
		private http: HttpClient,
		private router: Router,
		private errorService: ErrorService
	) { }
	private getNodoRaizUrl: string = environment.rest + '/Tmmv/GetNodoRaiz';
	private getNodoRaizRSUrl: string = environment.rest + '/Tmmv/GetNodoRaizRS';
	private getHijosUrl: string =
		environment.rest + '/Tmmv/GetHijosByTmmvNodoModel';
	private getMixByModeloUrl: string = environment.rest + '/Tmmv/GetMixByModelo';
	private getPorcentajesMixUrl: string =
		environment.rest + '/Tmmv/getPorcentajesMix';
	private setMixByModeloUrl: string = environment.rest + '/Tmmv/SetMixByModelo';
	private updatePorcentajesMixUrl: string =
		environment.rest + '/Tmmv/UpdatePorcentajesMix';
	private getTmmvNodosUrl = environment.rest + '/Tmmv/GetTmmvNodos';
	private updateFechaMixUrl = environment.rest + '/Tmmv/UpdateFechaMix';
	private deleteMixUrl = environment.rest + '/Tmmv/DeleteMix';
	private despersonalizarMixUrl = environment.rest + '/Tmmv/DespersonalizarMix';
	private getTmmvHastaModelosUrl: string =
		environment.rest + '/Tmmv/GetTmmvHastaModelos';
	private getNodosByProfundidadUrl: string =
		environment.rest + '/Tmmv/GetNodosByProfundidad';
	private getTmmvCompletoUrl: string =
		environment.rest + '/Tmmv/GetTmmvCompleto';
	private getTmmvLazyUrl: string = environment.rest + '/Tmmv/GetMinimalTmmv';
	private getDescripcionesUrl: string =
		environment.rest + '/Tmmv/getDescripciones';
	private getMinimalTmmvByIdsClasificacionesUrl: string =
		environment.rest + '/Tmmv/GetMinimalTmmvByIdsClasificaciones';

	private getRamaNodoUrl: string =
		environment.rest + '/Tmmv/GetRamaNodo';

	private getVersionesTmmvMinimalUrl: string = environment.rest + '/Tmmv/GetVersionesTmmvMinimal';

	private getNodoRaizTMMVUrl: string = environment.rest + '/Tmmv/GetNodoRaizTMMV';
	private addNodoRaizTMMVUrl: string = environment.rest + '/Tmmv/AddNodoRaizTMMV';

	headers = new HttpHeaders({ 'Content-Type': 'application/json' });

	getNodoRaiz(arbolRS: boolean=false): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http.post<Respuesta>(this.getNodoRaizUrl, {arbolRS}, options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			}),
			catchError(this.errorService.handleError<Respuesta>(`get getNodoRaiz`))
		);
	}

	getHijos(
		padre: any,
		tipoVersiones: number,
		mostrarDiscontinuadas: boolean = true,
		forzarArbolHeredado: boolean = false
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getHijosUrl,
				{ padre, tipoVersiones, mostrarDiscontinuadas, forzarArbolHeredado },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get hijos idClasificacion=${padre.idNodo}`
					)
				)
			);
	}
	getMixesByModelo(
		idClasificacion: number,
		fechaConsultada: Date
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getMixByModeloUrl,
				{ idClasificacion, fechaConsultada },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get mix idClasificacion=${idClasificacion}`
					)
				)
			);
	}

	getPorcentajesMix(idClasificacion: number, mix: Mix): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getPorcentajesMixUrl,
				{ idClasificacion, mix },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get porcentajes idClasificacion=${idClasificacion}, mix=${mix}`
					)
				)
			);
	}

	setMixByModelo(
		idClasificacion: number,
		mix: Mix,
		fecha: Date
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.setMixByModeloUrl,
				{ idClasificacion, mix, fecha },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`set mix idClasificacion=${idClasificacion}, mix=${mix}`
					)
				)
			);
	}

	updatePorcentajesMix(
		versiones: Array<VersionPorcentaje>
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(this.updatePorcentajesMixUrl, { versiones }, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(this.errorService.handleError<Respuesta>(`update mix`))
			);
	}

	updateFechaMix(
		idMix: number,
		idClasificacion: number,
		fecha: Date
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.updateFechaMixUrl,
				{ idMix, idClasificacion, fecha },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`update fecha Mix idMix=${idMix}`
					)
				)
			);
	}
	deleteMix(idMix: number, idClasificacion: number): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(this.deleteMixUrl, { idMix, idClasificacion }, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`delete mix=${idMix}`)
				)
			);
	}
	despersonalizarMix(idMix: number, fecha: Date): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(this.despersonalizarMixUrl, { idMix, fecha }, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`desperzonalizar mix=${idMix}`
					)
				)
			);
	}

	// Obtengo los nodos de terminal, marca y modelo iniciales
	public getTmmvNodos(idNodoRaiz: number): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(this.getTmmvNodosUrl, { idNodoRaiz }, options)

			.pipe(
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getTmmvNodos  idNodoRaiz=${idNodoRaiz}`
					)
				)
			);
	}

	public getTmmvHastaModelos(idNodoRaiz: number): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(this.getTmmvHastaModelosUrl, { idNodoRaiz }, options)

			.pipe(
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getTmmvHastaModelos  idNodoRaiz=${idNodoRaiz}`
					)
				)
			);
	}

	// Obtengo los nodos de terminal, marca y modelo iniciales
	public getNodosByProfundidad(
		profundidad: number,
		traerHijos: boolean,
		forzarArbolHeredado: boolean,
		soloMigraNyvus: boolean
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getNodosByProfundidadUrl,
				{ profundidad, traerHijos, forzarArbolHeredado, soloMigraNyvus },
				options
			)

			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getNodosByProfundidad  profundidad=${profundidad}`
					)
				)
			);
	}

	public getTmmvCompleto(
		profundidadInicial: number,
		idSegmentacion: number
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getTmmvCompletoUrl,
				{ profundidadInicial, idSegmentacion },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST getTmmvCompleto profundidadInicial=${profundidadInicial} idSegmentacion=${idSegmentacion}`
					)
				)
			);
	}

	public getTmmvLazy(
		configuracion: ConfiguracionArbolLazy
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(this.getTmmvLazyUrl, { configuracion }, options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST getTmmvLazy configuracion=${configuracion}`
					)
				)
			);
	}

	public getMinimalTmmvByIdsClasificaciones(
		idsClasificaciones: number[]
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getMinimalTmmvByIdsClasificacionesUrl,
				{ idsClasificaciones },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST getMinimalTmmvByIdsClasificaciones`
					)
				)
			);
	}

	public getRamaNodo(
		idNodo: number,
		profundidad: number
	): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http
			.post<Respuesta>(
				this.getRamaNodoUrl,
				{ idNodo, profundidad },
				options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`GET getRamaNodo`
					)
				)
			);
	}

	public getVersionesTmmvMinimal(idClasificacion: number): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http.post<Respuesta>(this.getVersionesTmmvMinimalUrl, { idClasificacion }, options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			}),
			catchError(
				this.errorService.handleError<Respuesta>(
					`GET getVersionesTmmvMinimal`
				)
			)
		);
	}

	getNodoRaizTMMV(arbolRS: boolean): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http.post<Respuesta>(this.getNodoRaizTMMVUrl, {arbolRS}, options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			}),
			catchError(this.errorService.handleError<Respuesta>(`get getNodoRaizTMMV`))
		);
	}

	addNodoRaizTMMV(): Observable<Respuesta> {
		let options = { headers: this.headers, withCredentials: true };
		return this.http.post<Respuesta>(this.addNodoRaizTMMVUrl, {}, options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			}),
			catchError(this.errorService.handleError<Respuesta>(`get addNodoRaizTMMV`))
		);
	}

	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<Respuesta> => {
			// TODO: send the error to remote logging infrastructure
			console.error(error); // log to console instead

			// TODO: better job of transforming error for user consumption
			console.log(`${operation} failed: ${error.message}`);

			//   this.router.navigate(['error-404',{codigoError:404}]);
			this.router.navigate(['error-404'], {
				queryParams: {
					codigoError: error.error.Code,
					mensaje: error.error.Message,
				},
			});

			// Let the app keep running by returning an empty result.
			return of(new Respuesta());
		};
	}
}
